<template style="height: 100%;">
  <div class="File_add_record">

    <el-descriptions style="width: 98%;margin-left: 1%;padding-top: 20px;" class="margin-top" :column="3" :size="size" border>
      <el-descriptions-item>
        <template slot="label">
          咨询人
        </template>
        {{ this.form.UserID }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          军人证件号
        </template>
        {{ this.form.RealName }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          咨询时间
        </template>
        <el-date-picker value-format="yyyy-MM-dd" v-model="form.TestTime" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-descriptions-item>

      <el-descriptions-item :span="3">
        <template slot="label">
          心理状态
        </template>
        <el-radio v-model="form.PsychologyStatus" label="1">红色预警</el-radio>
        <el-radio v-model="form.PsychologyStatus" label="2">橙色预警</el-radio>
        <el-radio v-model="form.PsychologyStatus" label="3">黄色预警</el-radio>
        <el-radio v-model="form.PsychologyStatus" label="4">蓝色预警</el-radio>
        <el-radio v-model="form.PsychologyStatus" label="5">绿色预警</el-radio>
      </el-descriptions-item>

      <el-descriptions-item :span="3">
        <template slot="label">
          身体状况
        </template>
        <el-radio v-model="form.BodyStatus" label="1">红色预警</el-radio>
        <el-radio v-model="form.BodyStatus" label="2">橙色预警</el-radio>
        <el-radio v-model="form.BodyStatus" label="3">黄色预警</el-radio>
        <el-radio v-model="form.BodyStatus" label="4">蓝色预警</el-radio>
        <el-radio v-model="form.BodyStatus" label="5">绿色预警</el-radio>
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          心理医师
        </template>
        <el-input v-model="form.PsychologyPhysician" placeholder="请输入心理医师"></el-input>
      </el-descriptions-item>

      <el-descriptions-item :span="2">
        <template slot="label">
          咨询地点
        </template>
        <el-input v-model="form.ConsultaAddress" placeholder="请输入咨询地点"></el-input>
      </el-descriptions-item>

      <el-descriptions-item :span="2">
        <template slot="label">
          事件内容
        </template>
        <el-input type="textarea" :rows="2" placeholder="请输入事件内容" v-model="form.MatterContent"></el-input>
      </el-descriptions-item>

      <el-descriptions-item :span="2">
        <template slot="label">
          事件处理
        </template>
        <el-input type="textarea" :rows="2" placeholder="请输入事件处理" v-model="form.MatterSolve"></el-input>
      </el-descriptions-item>

      <el-descriptions-item :span="3">
        <template slot="label">
          备注
        </template>
        <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="form.Bak"></el-input>
      </el-descriptions-item>

      <el-descriptions-item :span="3">
        <template slot="label">
          记录人
        </template>
        <el-input v-model="form.Recorder" placeholder="请输入记录人"></el-input>
      </el-descriptions-item>

    </el-descriptions>

    <div style="width: 100%;margin: auto;">
      <el-button style="margin-top: 20px;margin-left: 47%;" @click="submit()" type="primary">提交</el-button>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      size: '',
      form: {
        UserID: '',
        RealName: '',
        TestTime: [],
        PsychologyStatus: '1',
        BodyStatus: '1',
        PsychologyPhysician: '',
        ConsultaAddress: '',
        MatterContent: '',
        MatterSolve: '',
        Recorder: '',
      },
    }
  },
  components: {

  },
  methods: {
    submit() {
      this.$Http_Post('SoldierFile/ImportantRecord', { "from": this.form }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    }
  },
  watch: {

  },
  mounted() {
    this.$Http_Post('SoldierFile/SoldierName', { "UserID": this.$route.query.id }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.form.UserID = res.Data[0].UserID;
        this.form.RealName = res.Data[0].RealName;
      }
    })
  }
}
</script>
<style>
  .File_add_record{height: 100%;background-color: #fff;}
</style>
